export function assert(
  condition: unknown,
  message?: string
): asserts condition {
  if (!condition) {
    throw new Error(message || "Assertion failed");
  }
}

export function formatMoney(x: number, moneda = "ARS") {
  const digits = moneda === "ARS" ? 0 : 2;

  return x.toLocaleString("es-AR", {
    minimumFractionDigits: digits,
    maximumFractionDigits: digits,
  });
}

export function groupBy<T>(V: T[], fn: (v: T) => string) {
  const result: Record<string, T[]> = {};

  V.forEach((v) => {
    const k = fn(v);
    result[k] = [...(result[k] || []), v];
  });

  return result;
}

export function sum(vs: number[]) {
  return vs.reduce((a, b) => a + b, 0);
}

export function clamp<T>(v: T, min: T | undefined, max: T | undefined) {
  return min != undefined && min > v
    ? min
    : max != undefined && max < v
      ? max
      : v;
}

export function bindProps<
  T extends React.ComponentType<any>,
  P extends Partial<React.ComponentProps<T>>,
>(Component: T, boundProps: P) {
  type RemainingProps = Omit<React.ComponentProps<T>, keyof P>;

  return (props: RemainingProps) => {
    return <Component {...(boundProps as any)} {...props} />;
  };
}
